// extracted by css-extract-rspack-plugin
export default {"cls1":"LoswpExitIntentModal-cls1_vWx","cls2":"LoswpExitIntentModal-cls2_GNZ LoswpExitIntentModal-cls1_vWx"};